import { Box, Button, FormControlLabel, Switch } from '@mui/material';
import TranscriptParagraph from './TranscriptParagraph';

export default function TranscriptView({
  transcriptParagraphs,
  activeSegment,
  activeWord,
  autoScrollEnabled,
  setAutoScrollEnabled,
  autoScrollPaused,
  resumeAutoScroll,
  activeElementRef,
  onTimestampClick,
  onWordClick
}) {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          mb: 1.5,
          flexWrap: 'wrap'
        }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={autoScrollEnabled}
              onChange={(event) => setAutoScrollEnabled(event.target.checked)}
              size="small"
            />
          }
          label="Auto-scroll"
          sx={{ mr: 0 }}
        />
        {autoScrollEnabled && autoScrollPaused && (
          <Button size="small" onClick={resumeAutoScroll}>
            Resume auto-scroll
          </Button>
        )}
      </Box>

      {transcriptParagraphs.length === 0 ? (
        <Box sx={{ py: 4, textAlign: 'center', color: 'text.secondary' }}>
          No transcript segments found.
        </Box>
      ) : (
        transcriptParagraphs.map((paragraph) => {
          const isActive = paragraph.segments.some(
            (segment) => activeSegment?.start === segment.start
          );

          return (
            <TranscriptParagraph
              key={`${paragraph.start}-${paragraph.end}`}
              segments={paragraph.segments}
              isActive={isActive}
              activeSegment={activeSegment}
              activeWord={isActive ? activeWord : null}
              onTimestampClick={onTimestampClick}
              onWordClick={onWordClick}
              elementRef={isActive && autoScrollEnabled ? activeElementRef : null}
            />
          );
        })
      )}
    </Box>
  );
}
